export const fetchOverview = async (request, city, year) => {
    try {
        const res = await request(
            "GET",
            `/v1/city-profile/overview?location=${city}&year=${year}`,
            {},
            "survey_service"
        );
        return res;
    } catch (err) {
        console.error(err);
    }
};
export const fetchInfrastructure = async (request, city, year) => {
    try {
        const res = await request(
            "GET",
            `/v1/city-profile/infrastructure?location=${city}&year=${year}`,
            {},
            "survey_service"
        );
        return res;
    } catch (err) {
        console.error(err);
    }
};
export const fetchInstitutionalCapacity = async (request, city, year) => {
    try {
        const res = await request(
            "GET",
            `/v1/city-profile/institutional_capacity?location=${city}&year=${year}`,
            {},
            "survey_service"
        );
        return res;
    } catch (err) {
        console.error(err);
    }
};
export const fetchIndicators = async (request, city, year) => {
    try {
        const res = await request(
            "GET",
            `/v1/city-profile/indicators?location=${city}&year=${year}`,
            {},
             "survey_service"
        );
        return res;
    } catch (err) {
        console.error(err);
    }
};






export const fetchSludgeImage = async (request, city, year) => {
    // Placeholder: In real scenario, fetch from API
    return "https://i.imgur.com/B10DRoY.png";
};


export const fetchCityName = async (request,id) => {

    try {
        const response = await request(
            "GET",
            `/v1/survey/locations/city-profile`,
            {},
            "survey_service"
        );
        const city = response.find(c => c.id === id);
       if (!city) return null;

    return {
        city_name: `${city.name} ${city.type === "CITY_CORPORATION" ? "City Corporation" : "Municipality"}`
    };

    } catch (error) {
        console.log(error);
    }
    
};
